export function mapSequenceNumber(response: string | number): number {
    if (!response) {
        return 0;
    }

    return Number(response);
}
